import React, { useState, Fragment } from 'react';
import TagsInput from 'react-tagsinput';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Badge,
  Input,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
  faTags,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SuggestResponse({
  reloadBotResponse,
  elem,
  text,
  buttons,
  codeIndex,
  dialogIndex,
  dialogUpdate,
}) {
  const [dialogButtons, setdialogButtons] = useState(
    buttons === undefined ? [] : buttons
  );
  const [suggestionText, setText] = useState(text === undefined ? '' : text);
  const [isEditing, setIsEditing] = useState(false);
  const [postData, setPostData] = useState(elem);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    const data = { ...postData };
    data.messages.splice(codeIndex, 1);
    dialogUpdate(postData, dialogIndex);
    toggle();
  };
  const handleSave = () => {
    const data = { ...postData };
    data.messages[codeIndex].buttons = dialogButtons;
    data.messages[codeIndex].text = suggestionText;
    dialogUpdate(data, dialogIndex);
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
    setText(text === undefined ? '' : text);
    setdialogButtons(buttons === undefined ? [] : buttons);
  };
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  const handleTagChange = (event) => {
    setdialogButtons(event);
    console.log(event);
  };
  const handleTextChange = (e) => {
    setText(e.target.value);
  };
  return (
    <Card className="mb-2">
      <CardBody>
        {isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <Colxx xxs="6">
                  <FontAwesomeIcon icon={faLaptopCode} />
                  <span> </span>
                  Quick Reply
                </Colxx>
                <Colxx xxs="6">
                  <div className="float-right">
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <b> </b>
                    <Button
                      color="light"
                      className="add-button"
                      size="xs"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Colxx>
              </Row>{' '}
            </CardTitle>
            <Row className="mb-2">
              <Colxx xxs="12">
                <Input
                  type="text"
                  value={suggestionText}
                  onChange={(event) => handleTextChange(event)}
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <TagsInput
                  inputProps={{ placeholder: 'Add Button' }}
                  value={dialogButtons}
                  onChange={(event) => handleTagChange(event)}
                />
              </Colxx>
            </Row>
          </Fragment>
        ) : (
          <CardTitle>
            <Row>
              <Colxx xxs="8">
                <FontAwesomeIcon icon={faTags} />
                <span> </span>
                Quick Reply
              </Colxx>
              <Colxx xxs="4">
                <div className="float-right">
                  <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={handleEdit}
                  />
                  <b> | </b>
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    color="#e57373"
                    cursor="pointer"
                    onClick={toggle}
                  />
                </div>
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <p>{suggestionText}</p>
              </Colxx>
              <Colxx xxs="12">
                {buttons && (
                  <Fragment>
                    {buttons.map((tag, index) => {
                      return (
                        <Fragment>
                          {' '}
                          <Badge color={generateRandomColor()}>
                            {tag}
                          </Badge>{' '}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                )}
              </Colxx>
            </Row>
            <Modal isOpen={deleteVisible} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                This message will be deleted!
              </ModalHeader>
              <ModalBody>
                <Button color="danger" onClick={() => handleDelete()} size="xs">
                  Delete
                </Button>
                <Button
                  className="ml-2"
                  color="dark"
                  outline
                  size="xs"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
          </CardTitle>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(SuggestResponse));
